const P = {
  Ipp: "IPP",
  Pipp: "PIPP",
  All: "ALL",
  Distinct: "DISTINCT"
};
export {
  P as t
};
//# sourceMappingURL=PmpProjection-7861f4f7.mjs.map
